import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@fuse/services/common.service';
import { Enums } from '@fuse/utils/systemEnums';
import * as moment from 'moment';
import { Location } from '@angular/common';
import { GroupsService } from '../groups.service';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { MatDialog } from '@angular/material/dialog';
import { AddMoreFieldsComponent } from '@fuse/Dialog/add-more-fields/add-more-fields.component';
import { ToolbarService } from 'app/layout/components/toolbar/toolbar.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AddNewDynamicVariableComponent } from '@fuse/Dialog/add-new-dynamic-variable/add-new-dynamic-variable.component';

@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.scss'],
  providers: [DatePipe]
})
export class AddContactComponent implements OnInit, OnDestroy {

  form: UntypedFormGroup
  enumsData: any;
  currentDate = new Date()
  labelShown = false
  editId: any;
  groupId: string;
  countryCode: any;
  selectedCountryCode: number;

  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  defCountryCode: any = 'IN';
  defCountryCodewh: any = 'IN';

  private _onDestroy = new Subject<void>();

  today = new Date();

  constructor(
    private _fb: UntypedFormBuilder,
    public _commonService: CommonService,
    private location: Location,
    private _groupsService: GroupsService,
    private route: Router,
    private _ToolbarService: ToolbarService,
    private _activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private _matDialog: MatDialog
  ) {
    this.enumsData = Enums;


  }


  ngOnInit(): void {
    this.getcountryCode()

    // 
    // if (this._groupsService.contactDetail) {

    // } else {
    //   this.createForm();
    // }
    this._activatedRoute.queryParams.subscribe((queryParamsData) => {
      if (queryParamsData?.groupId) {
        console.log("queryParamsData", atob(queryParamsData.groupId));
        this.groupId = atob(queryParamsData.groupId)
      }
    })

    this._activatedRoute.params.subscribe((params) => {
      console.log("params", params);

      if (params.editId) {
        this.editId = params.editId;
        this.createForm(this._groupsService.contactDetail);
      } else {
        this.editId = undefined;
        this.createForm();
        this._groupsService.contactDetail = '';

      }
    });

    this.setToolBarTitle();

    this.getDynamicFields()

    this.form.get('mobileNo').valueChanges.subscribe((result) => {
      console.log("result", result);
      if ((result?.countryCode === 'CN')) {
        if ((String(result?.e164Number).length == 14 || String(result?.e164Number).length == 13)) {
          this.form.get('mobileNo').setErrors(null);
        } else {
          this.form.get('mobileNo').setErrors({ validatePhoneNumber: { valid: false } });
        }
      }
    })


    this.form.get('whatsAppNo').valueChanges.subscribe((result) => {
      console.log("result", result);
      if ((result?.countryCode === 'CN')) {
        if ((String(result?.e164Number).length == 14 || String(result?.e164Number).length == 13)) {
          this.form.get('whatsAppNo').setErrors(null);
        } else {
          this.form.get('whatsAppNo').setErrors({ validatePhoneNumber: { valid: false } });
        }
      }
    })
  }

  getDynamicFields() {
    this._commonService.getDynamicFieldList({ isAddContact: 1 }).then((result: any) => {
      if (result?.data) {
        this.createDynamicFormControls(result.data);
      }
    })
  }

  createDynamicFormControls(fields: any[]) {
    fields.forEach(field => {
      const validators = [];
      if (field.isAddRequired == 1) {
        validators.push(Validators.required);
      }

      if (field.createField === 'email') {
        validators.push(Validators.email);
      }

      // Get the existing value if it exists in the contact detail
      const existingValue = this._groupsService.contactDetail?.[field.createField] || '';

      console.log("parseDDMMYYYYToISOString", existingValue)

      if (field.createField === 'dob' || field.createField === 'significantdate' || field.createField === 'expiryDate' || field.createField === 'startDate' || field.createField === 'endDate') {
        if (existingValue) {
          const date = new Date(existingValue);
          const formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
          this.form.addControl(field.createField, new FormControl(formattedDate, validators));
        }
        else {
          this.form.addControl(field.createField, new FormControl(existingValue || '', validators));
        }
      } else {
        this.form.addControl(field.createField, new FormControl(existingValue || '', validators));
      }


      // this.form.addControl(field.createField, new FormControl(existingValue, validators));
    });
  }

  isDateField(fieldName: string): boolean {
    const dateFields = ['dob', 'significantdate', 'expiryDate', 'startDate', 'endDate'];
    return dateFields.includes(fieldName);
  }

  getFieldLabel(fieldName: string): string {
    // Convert camelCase to Title Case
    return fieldName.replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase());
  }

  setToolBarTitle() {
    if (this.editId) {
      // for title
      this._ToolbarService._ToolBarTitle.next('Edit Contact');
      // for btn
      this._ToolbarService._isBackBtnShow.next(true);
    } else {
      // for title
      this._ToolbarService._ToolBarTitle.next('Create New Contact');
      // for btn
      this._ToolbarService._isBackBtnShow.next(true);
    }
  }


  createForm(data?) {
    if (data?.countryCode) {
      this.defCountryCode = data.countryCode;
    }
    if (data?.countryCodeWh) {
      this.defCountryCodewh = data.countryCodeWh;
    }

    console.log("data in the create form", data);


    this.form = this._fb.group({
      title: [data?.title || '', [Validators.required]],
      firstName: [data?.firstName || '', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      lastName: [data?.lastName || '', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      mobileNo: [data?.mobileNo || '', [Validators.required]],
      whatsAppNo: [data?.whatsAppNo || ''],
      // dob: [data?.dob ? moment(new Date(data.dob)) : null],


    });

    // Add phone number validation
    this.setupPhoneValidation();
  }

  private setupPhoneValidation(): void {
    // Mobile number validation
    this.form.get('mobileNo').valueChanges.pipe(
      takeUntil(this._onDestroy)
    ).subscribe((result) => {
      if (result?.countryCode === 'CN') {
        const isValidLength = String(result?.e164Number).length === 14 || String(result?.e164Number).length === 13;
        this.form.get('mobileNo').setErrors(isValidLength ? null : { validatePhoneNumber: { valid: false } });
      }
    });

    // WhatsApp number validation
    this.form.get('whatsAppNo').valueChanges.pipe(
      takeUntil(this._onDestroy)
    ).subscribe((result) => {
      if (result?.countryCode === 'CN') {
        const isValidLength = String(result?.e164Number).length === 14 || String(result?.e164Number).length === 13;
        this.form.get('whatsAppNo').setErrors(isValidLength ? null : { validatePhoneNumber: { valid: false } });
      }
    });
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const formValue = this.form.value;
    console.log('Form Value:', formValue); // Debug log to see all form values

    const payload = {
      ...(this.editId && { id: this.editId }),
      ...formValue, // Include all form values
      groupIds: this.groupId ? [this.groupId] : []
    };

    // Clean up the payload by removing any undefined or null values
    Object.keys(payload).forEach(key => {
      if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
        delete payload[key];
      }
    });

    payload.mobileNo = payload.mobileNo?.number?.split(" ").join("") || '';
    payload.whatsAppNo = payload.whatsAppNo?.number?.split(" ").join("") || '';

    console.log('Final Payload:', payload); // Debug log to see the final payload


    if (payload?.expiryDate) {
      payload.expiryDate = this.formatDateToDDMMYYYY(payload.expiryDate);
    }
    if (payload?.dob) {
      payload.dob = this.formatDateToDDMMYYYY(payload.dob);
    }
    if (payload?.startDate) {
      payload.startDate = this.formatDateToDDMMYYYY(payload.startDate);
    }
    if (payload?.significantdate) {
      payload.significantdate = this.formatDateToDDMMYYYY(payload.significantdate);
    }
    if (payload?.endDate) {
      payload.endDate = this.formatDateToDDMMYYYY(payload.endDate);
    }

    const serviceCall = this.editId
      ? this._groupsService.updateContact(payload)
      : this._groupsService.addContact(payload);

    serviceCall.then((result: any) => {
      if (result?.status === 200) {
        this.location.back();
      }
    }).catch(error => {
      console.error('Error submitting contact:', error);
    });
  }

  selectcountryCode(event) {
    this.selectedCountryCode = parseInt(event.value);
  }

  getcountryCode() {
    this._commonService.getAllCountries().then((result: any) => {
      if (result.length)
        this.countryCode = result;
      else
        this.countryCode = [];
    })
  }

  /* MAKE FORM CONTROLS */
  get dynamicFields(): FormArray {
    return this.form.controls["dynamicFields"] as FormArray;
  }

  // addCustomField(){
  //   this._matDialog.open(AddMoreFieldsComponent, {
  //     minWidth : '320px',
  //     autoFocus : false,
  //     panelClass: "no-padding-dialog",
  //   }).afterClosed().subscribe((fieldData) => {
  //     if(fieldData){
  //       let object = {}
  //       object[fieldData.fieldName] = '';
  //       (<FormArray>this.form.get("dynamicFields")).push(
  //         this._fb.group(object)
  //       );
  //       console.log("form value", this.form);
  //     }
  //   })
  // }

  formatDateToDDMMYYYY(isoString) {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }




  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }


  addNewField() {
    this._matDialog.open(AddNewDynamicVariableComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '420px',
      autoFocus: false,
      data: {
        fields: this.dynamicFields
      }
    }).afterClosed().subscribe((fieldData) => {
      if (fieldData) {

        this.getDynamicFields();
      }
    })
  }

}
